import { render, staticRenderFns } from "./Lawyers.vue?vue&type=template&id=1096ca14&scoped=true&"
import script from "./Lawyers.vue?vue&type=script&lang=js&"
export * from "./Lawyers.vue?vue&type=script&lang=js&"
import style0 from "./Lawyers.vue?vue&type=style&index=0&id=1096ca14&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1096ca14",
  null
  
)

export default component.exports